<template>
  <div class="product-gallery-wrapper">
    <div class="product-gallery-full-screen" v-if="full_screen" @click="fullScreenContainerClicked($event)">
      <Arrow class="nav-arrow" direction="left" @click="prevImage();" />
      <div class="product-gallery-full-screen-container">
        <img :src="current_full" />
      </div>
      <Arrow class="nav-arrow" direction="right" @click="nextImage();" />
      <div class="close-button" @click="closeFullScreen()">
        <svg-file icon="close" />
      </div>
    </div>
    <div class="product-gallery">
      <ImageZoom :image="current_full" :width="imageWidth || 350" :height="imageHeight || 450" />
      <!-- <svg-file class="search-icon" icon="search" @click="openFullScreen()" /> -->
      <div class="dots" v-if="images.length > 1">
        <div v-for="(image, i) in images" v-bind:class="{ active: i == index }" :key="i" @click="setImage(i)"></div>
      </div>
      <Arrow direction="left" class="slider-button-prev" @click="prevImage()" v-show="index > 0" />
      <Arrow direction="right" class="slider-button-next" @click="nextImage()" v-show="index < images.length - 1" />
    </div>
    <div class="product-gallery-thumbnails flex flex-wrap small-margin-top responsive-hide" v-if="images.length && images[0].urls['webshop-gallery-preview']">
      <div
        class="product-gallery-thumbnail flex-center"
        v-for="(image, i) in images"
        @click="setImage(i)"
        v-bind:class="{
          active: i == index
        }"
        :key="i"
      >
        <img :src="image.urls['webshop-gallery-preview']" />
      </div>
    </div>
  </div>
</template>

<script>
import Arrow from './Arrow.vue'
import ImageZoom from './ImageZoom.vue'

export default {
  props: {
    images: {
      type: Array,
      default: () => []
    },
    imageWidth: {
      type: Number,
      default: 0
    },
    imageHeight: {
      type: Number,
      default: 0
    }
  },
  components: {
    Arrow,
    ImageZoom
  },
  data: () => ({
    index: 0,
    current: '',
    current_full: '',
    full_screen: false
  }),
  methods: {
    setImage (index) {
      this.index = index
      this.current = this.images[index].urls['webshop-gallery-preview']
      this.current_full = this.images[index].urls.original
    },
    openFullScreen () {
      this.full_screen = true
    },
    closeFullScreen () {
      this.full_screen = false
    },
    nextImage () {
      if (this.index >= this.images.length - 1) {
        this.setImage(0)
      } else {
        this.setImage(this.index + 1)
      }
    },
    prevImage () {
      if (this.index == 0) {
        this.setImage(this.images.length - 1)
      } else {
        this.setImage(this.index - 1)
      }
    },
    fullScreenContainerClicked (event) {
      if (typeof event.target.className === 'string') {
        if (event.target.className.indexOf('product-gallery-full-screen') >= 0) {
          this.closeFullScreen()
        }
      }
    }
  },
  mounted () {
    if (this.images.length) {
      this.setImage(0)
    }
  },
  watch: {
    images (newValue, oldValue) {
      if (this.images.length) {
        this.setImage(0)
      }
    }
  },
  created () {
    document.addEventListener('keyup', event => {
      switch (event.which) {
        case 39:
          this.nextImage()
          break
        case 37:
          this.prevImage()
          break
      }
    })
  }
}
</script>

<style lang="less" scoped>
@product-gallery-width: 350px;
@spacing: 30px;
@spacing-small: 15px;

.product-gallery-full-screen {
	position: absolute;
	top: 0px;
	right: 0px;
	bottom: 0px;
	left: 0px;
	display: flex;
	align-items: center;
	justify-content: center;
	position: fixed;
	background: rgba(0,0,0,0.8);
	z-index: 1100;
	.product-gallery-full-screen-container {
    display: flex;
    align-items: center;
    justify-content: center;
		max-height: 90vh;
		max-width: 60vw;
		background: #fff;
		img {
			max-height: 90vh;
			max-width: 60vw;
		}
	}
	.nav-arrow {
		position: fixed;
		top: ~"calc(50% - 25px)";
		cursor: pointer;
		svg {
			fill: #fff;
			height: 50px;
			width: 50px;
		}
		&.left {
			left: @spacing;
		}
		&.right {
			right: @spacing;
		}
	}
	.product-gallery-full-screen-nav {
		position: fixed;
		bottom: @spacing;
		width: 200px;
		left: ~"calc(50% - 100px)";
	}
	.close-button {
		cursor: pointer;
		position: fixed;
		top: @spacing;
		right: @spacing;
		svg {
			width: 40px;
			height: 40px;
			fill: #fff;
		}
	}
}

.product-gallery {
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	cursor: pointer;
	width: @product-gallery-width;
	height: 450px;
	.arrow {
		position: absolute;
		top: 40%;
		svg {
			fill: rgba(0,0,0,0.8);
			cursor: pointer;
			width: 50px;
			height: 50px;
		}
		&.left {
			left: 0px;
		}
		&.right {
			right: 0px;
		}
	}
	img.not-zoomed {
		max-width: 90%;
		max-height: 90%;
		min-width: 90%;
	}
	.search-icon {
		position: absolute;
		right: @spacing-small;
		top: @spacing-small;
		background: #fff;
		padding: 5px;
		border-radius: 50%;
		width: 20px;
		height: 20px;
		flex-grow: 0;
		flex-shrink: 0;
		svg {
			width: 20px;
			height: 20px;
		}
	}
	.product-gallery-image {
		border: 1px solid #ddd;
		width: 350px;
		height: 450px;
		background-size: cover;
		background-position: center center;
	}
}
.product-gallery-thumbnails {
	width: @product-gallery-width;
	.product-gallery-thumbnail {
		margin-right: 10px;
		width: 60px;
		height: 80px;
		cursor: pointer;
		opacity: 0.7;
		transition: 120ms;
		img {
			max-width: 100%;
			max-height: 100%;
		}
		&:hover, &.active {
			opacity: 1;
		}
	}
}
</style>
